// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const MfrPricing: React.FC = () => {
    return <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 54 40" enableBackground="new 0 0 54 40" xmlSpace="preserve">
<g>
	<path d="M17.06,3.91c0.86,0.53,1.78,0.98,2.72,1.28c2.92,0.92,5.92,1.09,8.94,0.84c1.92-0.16,3.81-0.45,5.61-1.2
		c0.64-0.27,1.27-0.62,1.84-1.04c0.71-0.51,0.7-0.93,0-1.44c-0.49-0.36-1.02-0.67-1.57-0.91c-2.6-1.12-5.34-1.38-8.38-1.43
		c-1.61,0.02-3.49,0.17-5.35,0.62c-1.35,0.32-2.67,0.73-3.84,1.58C16.18,2.83,16.15,3.35,17.06,3.91z"/>
	<path d="M4.5,9.71c-1.35,0.32-2.67,0.74-3.84,1.58c-0.87,0.63-0.9,1.15,0.02,1.71c0.85,0.53,1.78,0.98,2.72,1.28
		c2.92,0.92,5.92,1.09,8.94,0.84c0.54-0.05,1.07-0.1,1.61-0.18V9.38c-1.31-0.19-2.67-0.26-4.1-0.28C8.23,9.12,6.35,9.27,4.5,9.71z"
		/>
	<path d="M0.01,23.2c0,0.77,0.01,1.58,0,2.38c-0.01,0.39,0.12,0.71,0.42,0.9c0.51,0.33,1.03,0.68,1.59,0.92
		c1.88,0.8,3.86,1.13,5.88,1.28c2.03,0.15,4.05,0.11,6.05-0.17v-3.6C9.31,25.59,4.67,25.02,0.01,23.2z"/>
	<path d="M0.01,16.42c0,0.77,0.01,1.58,0,2.38C0,19.2,0.12,19.51,0.43,19.71c0.51,0.33,1.03,0.68,1.59,0.92
		c1.88,0.8,3.86,1.13,5.88,1.28c2.03,0.15,4.05,0.11,6.05-0.17v-3.6C9.31,18.81,4.67,18.25,0.01,16.42z"/>
	<path d="M45.4,21.98c1.92-0.16,3.81-0.45,5.61-1.2c0.64-0.27,1.27-0.62,1.84-1.04c0.71-0.51,0.7-0.93,0-1.45
		c-0.49-0.36-1.02-0.67-1.57-0.91c-2.6-1.12-5.34-1.38-8.38-1.43c-1,0.01-2.11,0.09-3.24,0.24v5.66
		C41.55,22.13,43.47,22.14,45.4,21.98z"/>
	<path d="M49.53,28.13c1.17-0.29,2.32-0.69,3.3-1.45c0.22-0.18,0.51-0.45,0.53-0.7c0.06-0.91,0.02-1.83,0.02-2.68
		c-4.58,1.79-9.15,2.36-13.72,1.73v3.61c0.43,0.05,0.86,0.1,1.3,0.13C43.85,28.99,46.71,28.83,49.53,28.13z"/>
	<path d="M0.01,29.97c0,0.77,0.01,1.58,0,2.38c-0.01,0.39,0.12,0.71,0.42,0.9c0.51,0.33,1.03,0.68,1.59,0.92
		c1.88,0.8,3.86,1.13,5.88,1.28c2.03,0.15,4.05,0.11,6.05-0.17v-3.6C9.31,32.36,4.67,31.8,0.01,29.97z"/>
	<path d="M16.4,14.1c0,0.77,0.01,1.58-0.01,2.38c-0.01,0.39,0.12,0.71,0.42,0.9c0.52,0.33,1.03,0.68,1.59,0.92
		c1.88,0.8,3.86,1.13,5.88,1.28c2.89,0.22,5.75,0.05,8.57-0.65c1.17-0.29,2.32-0.69,3.3-1.45c0.22-0.18,0.51-0.45,0.53-0.7
		c0.06-0.91,0.02-1.83,0.02-2.68C29.93,16.75,23.2,16.76,16.4,14.1z"/>
	<path d="M16.4,7.33c0,0.77,0.01,1.58-0.01,2.38c-0.01,0.39,0.12,0.71,0.42,0.9c0.52,0.33,1.03,0.68,1.59,0.92
		c1.88,0.8,3.86,1.13,5.88,1.28c2.89,0.22,5.75,0.05,8.57-0.65c1.17-0.29,2.32-0.69,3.3-1.45c0.22-0.18,0.51-0.45,0.53-0.7
		c0.06-0.91,0.02-1.83,0.02-2.68C29.93,9.97,23.2,9.99,16.4,7.33z"/>
	<path d="M39.66,31.81v3.61c0.43,0.05,0.86,0.1,1.3,0.13c2.89,0.22,5.75,0.05,8.57-0.65c1.17-0.29,2.32-0.69,3.3-1.45
		c0.22-0.18,0.51-0.45,0.53-0.7c0.06-0.91,0.02-1.83,0.02-2.68C48.79,31.86,44.23,32.44,39.66,31.81z"/>
	<path d="M16.4,27.65c0,0.77,0.01,1.58-0.01,2.38c-0.01,0.39,0.12,0.71,0.42,0.9c0.52,0.33,1.03,0.68,1.59,0.92
		c1.88,0.8,3.86,1.13,5.88,1.28c2.89,0.22,5.75,0.05,8.57-0.65c1.17-0.29,2.32-0.69,3.3-1.45c0.22-0.18,0.51-0.45,0.53-0.7
		c0.06-0.91,0.02-1.83,0.02-2.68C29.93,30.3,23.2,30.31,16.4,27.65z"/>
	<path d="M16.4,20.88c0,0.77,0.01,1.58-0.01,2.38c-0.01,0.39,0.12,0.71,0.42,0.9c0.52,0.33,1.03,0.68,1.59,0.92
		c1.88,0.8,3.86,1.13,5.88,1.28c2.89,0.22,5.75,0.05,8.57-0.65c1.17-0.29,2.32-0.69,3.3-1.45c0.22-0.18,0.51-0.45,0.53-0.7
		c0.06-0.91,0.02-1.83,0.02-2.68C29.93,23.52,23.2,23.54,16.4,20.88z"/>
	<path d="M16.4,34.43c0,0.78,0.01,1.58-0.01,2.38c-0.01,0.39,0.12,0.71,0.42,0.9c0.52,0.33,1.03,0.68,1.59,0.92
		c1.88,0.8,3.86,1.13,5.88,1.28c2.89,0.22,5.75,0.05,8.57-0.65c1.17-0.29,2.32-0.69,3.3-1.45c0.22-0.18,0.51-0.45,0.53-0.7
		c0.06-0.91,0.02-1.83,0.02-2.68C29.93,37.07,23.2,37.09,16.4,34.43z"/>
</g>
</svg>;
};

export default React.memo(MfrPricing);
